import { ofType } from 'redux-observable';
import {
	switchMap,
	map,
	catchError,
} from 'rxjs/operators';
import { rxjsApiFetcher } from '../../../lib/general-utils';
import {
	actionTypes,
	notifyActions,
	captchaActions,
} from '../../../controller';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';
import { handleCaptchaEpicError } from '../../../lib/error-handler';

const {
	START_FETCH_CAPTCHA,
	START_CREATE_FORM_FILE_CONVERSATION_REPLY,
	CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED,
	START_CONTACT_CS_CONVERSATION,
	CONTACT_CS_CONVERSATION_SUCCESS,
	CONTACT_CS_CONVERSATION_FAILED,
	START_SELECT_CONVERSATION_TAG,
	SELECT_CONVERSATION_TAG_SUCCESS,
	SELECT_CONVERSATION_TAG_FAILED,
	START_CREATE_CONVERSATION_QA_FORM_REPLY,
	CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_QA_FORM_REPLY_FAILED,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	fetchCaptchaSuccessAction,
	fetchCaptchaFailedAction,
	detectCaptchaAction,
	detectCaptchaSuccessAction,
} = captchaActions;

export function fetchCaptchaEpic(action$) {
	return action$.pipe(
		ofType(START_FETCH_CAPTCHA),
		switchMap(() => rxjsApiFetcher
			.get('/captcha')
			.pipe(
				map(payload => payload.response),
				map(data => fetchCaptchaSuccessAction(data)),
				catchError(error => catchErrorForEpics(error, fetchCaptchaFailedAction, notifyErrorAction)),
			),
		),
	);
}

export function detectCaptchaEpic(action$) {
	return action$.pipe(
		ofType(
			START_CREATE_FORM_FILE_CONVERSATION_REPLY,
			START_CONTACT_CS_CONVERSATION,
			START_SELECT_CONVERSATION_TAG,
			START_CREATE_CONVERSATION_QA_FORM_REPLY,
		),
		map(() => detectCaptchaAction()),
	);
}

export function detectCaptchaSuccessEpic(action$) {
	return action$.pipe(
		ofType(
			CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
			CONTACT_CS_CONVERSATION_SUCCESS,
			SELECT_CONVERSATION_TAG_SUCCESS,
			CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS,
		),
		map(() => detectCaptchaSuccessAction()),
	);
}

export function detectCaptchaFailedEpic(action$) {
	return action$.pipe(
		ofType(
			CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED,
			CONTACT_CS_CONVERSATION_FAILED,
			SELECT_CONVERSATION_TAG_FAILED,
			CREATE_CONVERSATION_QA_FORM_REPLY_FAILED,
		),
		map(({ error }) => {
			const handleCaptchaEpicErrorAction = handleCaptchaEpicError(error);

			return handleCaptchaEpicErrorAction(error);
		}),
	);
}
